<script>
  let isOpenedAbout = false;

  export const viewAbout = () => {
    isOpenedAbout = true;
  };
  export const closeAbout = () => {
    isOpenedAbout = false;
  };
</script>

<div>
  {#if isOpenedAbout}
    <div class="wrapper">
      <div class="about-container">
        <h3>About</h3>
        <p class="description">
          使えば使うほどレベルが上がって使えるキーが増えていく電卓です。
          適当にキーを押したり計算したりして遊んでください。
          <br />
          整数12桁、小数点第6位(7位を四捨五入)まで対応。
          <br />
          あと最大レベルは15です。
        </p>
        <hr />
        <p>
          作った人：
          <a
            class="createdBy"
            href="https://twitter.com/de_teiu_tkg"
            target="_blank"
            rel="noopener"
          >
            @de_teiu_tkg
          </a>
        </p>
        <hr />
        <button on:click={closeAbout}>閉じる</button>
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .about-container {
    max-width: 95%;
    max-height: 95%;
    width: 680px;
    background-color: white;
    border: solid black 2px;
    padding: 5px;
    text-align: center;
    p {
      margin: 0px;
    }
  }
  .description {
    text-align: left;
  }
</style>
